// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"6704ae6b","85":"c707c105","93":"60926c71","228":"0d9915cf","231":"d1ca7085","378":"be6f7454","453":"eb324e0c","538":"0be8adfb","864":"a81ac28d","887":"d7eeca11","914":"322279e2","999":"1d9765a1"}[chunkId] + ".chunk.js";
};